import {ch} from "@renta-apps/athenaeum-react-common";
import Localizer from "@/localization/Localizer";

// Used in forms for HTML pattern validation
export const phoneNumberPattern = (length: number = 10): string => {
    if (ch.isDenmark) {
        return `\\+[0-9]{${length}}`;
    }
    return "\\+([0-9\\(])?([\\- \\(\\)]?[0-9][\\- \\(\\)]?){6,15}([0-9\\)])?";
};

export const validatePhoneNumber = (phoneNumber: string | null, length: number = 10): string | null => {
    if (ch.isDenmark) {
        return validatePhoneNumberExactLength(phoneNumber, length);
    }

    return validatePhoneNumberMinLengthAndPlusSign(phoneNumber);
};

export const validateOptionalPhoneNumberWithoutPlusSignRequired = (phoneNumber: string | null, length: number = 10): string | null => {
    if (!phoneNumber) {
        return null;
    }

    if (ch.isDenmark) {
        return validatePhoneNumberExactLength(phoneNumber, length);
    }

    return validatePhoneNumberMinLength(phoneNumber);
};

const validatePhoneNumberMinLengthAndPlusSign = (phoneNumber: string | null): string | null => {
    if (!phoneNumber) {
        return Localizer.genericValidationPhoneNumber;
    }

    // Require a + at the start
    const phoneRegex = /^\+([-\s()]*[0-9][-\s()]*){6,15}$/;
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    const digitCount = digitsOnly.length;

    const isValidFormat = phoneRegex.test(phoneNumber);
    const isValidLength = digitCount >= 6 && digitCount <= 15;

    return isValidFormat && isValidLength ? null : Localizer.genericValidationPhoneNumber;
};

const validatePhoneNumberMinLength = (phoneNumber: string | null): string | null => {
    if (!phoneNumber) {
        return Localizer.genericValidationPhoneNumber;
    }

    // + is optional
    const phoneRegex = /^\+?([-\s()]*[0-9][-\s()]*){6,15}$/;
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    const digitCount = digitsOnly.length;

    const isValidFormat = phoneRegex.test(phoneNumber);
    const isValidLength = digitCount >= 6 && digitCount <= 15;

    return isValidFormat && isValidLength ? null : Localizer.genericValidationPhoneNumber;
};

const validatePhoneNumberExactLength = (phoneNumber: string | null, length: number = 10): string | null => {
    const phoneRegex = new RegExp(`^\\+[0-9]{${length}}$`);
    return (!phoneNumber || !phoneRegex.test(phoneNumber))
        ? Localizer.get(Localizer.genericValidationPhoneNumberExactLength, length)
        : null;
};

export const validateMultipleEmails = (email: string | null): string | null => {
    const multipleEmailRegex = /^([\w+-.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)(?:[,;]\s*([\w+-.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+))*$/;
    return (!email || !email.match(multipleEmailRegex)) ? Localizer.validatorsEmail : null;
};